import { render, staticRenderFns } from "./article.vue?vue&type=template&id=6e8b62f6&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&id=6e8b62f6&lang=scss&scoped=scoped&"
import style1 from "./article.vue?vue&type=style&index=1&id=6e8b62f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b62f6",
  null
  
)

export default component.exports